import { ChangeEvent, useState, useEffect, useCallback } from "react";

export interface InputSearchConfig {
  placeholderTextSearch: string;
  disabledSearchInput: boolean;
  onChangeTextSearch: (e: ChangeEvent<HTMLInputElement>) => void;
  onBlurTextSearch: (e: ChangeEvent<HTMLInputElement>) => void;
}

export const useInputSearch = (onSearchChange?: (value: string) => void, delay: number = 500) => {
  const [searchValue, setSearchValue] = useState<string>("");
  const [debouncedValue, setDebouncedValue] = useState<string>("");

  const handleChangeSearch = (e: ChangeEvent<HTMLInputElement>) => {
    console.log("handleChangeSearch", e.target.value);
    const value = e.target.value;
    setSearchValue(value);
  };

  const handleBlurTextSearch = (e: ChangeEvent<HTMLInputElement>) => {
    // Handle blur event if needed
    console.log("onBlurTextSearch", e.target.value);
  };

  // Memoize the callback to prevent unnecessary re-renders
  const memoizedOnSearchChange = useCallback((value: string) => {
    if (onSearchChange) {
      onSearchChange(value);
    }
  }, [onSearchChange]);

  // Debounce effect
  useEffect(() => {
    // Only set up the timer if searchValue has actually changed and is not empty
    if (searchValue !== debouncedValue) {
      const timer = setTimeout(() => {
        setDebouncedValue(searchValue);
        memoizedOnSearchChange(searchValue);
      }, delay);

      return () => {
        clearTimeout(timer);
      };
    }
  }, [searchValue, debouncedValue, delay, memoizedOnSearchChange]);

  const inputSearchConfig: InputSearchConfig = {
    placeholderTextSearch: "Buscar usuario",
    disabledSearchInput: false,
    onChangeTextSearch: handleChangeSearch,
    onBlurTextSearch: handleBlurTextSearch,
  };

  return {
    inputSearchConfig,
    searchValue,
    setSearchValue,
    debouncedValue,
  };
}; 